module.exports = __webpack_public_path__ + "1793882494189/images/no-data.6265e46.svg";